/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from 'react';
import { Button } from '@material-ui/core';
import { ArrowForwardIos, ArrowBackIos } from "@material-ui/icons";

import SearchTable from "./table";

import { fetchSearchResults } from './util';

let requestSkip = 0;

export default function Pagination({
  searchValue,
  selectedLang,
  selectedSearchType,
  selectedSearchMode,
  selectedSearchField,
  selectedFromDate,
  selectedToDate,
  clicked,
  curLang,
  vocabularies,
  languages,
}) {


  const [loading, setLoading] = useState(true);
  const [skip, setSkip] = useState(0);
  const [data, setData] = useState([]);
  const [pageData, setPageData] = useState([]);
  const [numOfPaginationBtns, setNumOfPaginationBtns] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  const [pagesNumbers, setPagesNumbers] = useState({});
  const [totalResultsCount, setTotalResultsCount] = useState(0);
  const [maxScore, setMaxScore] = useState(1);

  useEffect(() => {
    handleResults();
  }, [])

  useEffect(() => {
    if (clicked) {
      requestSkip = 0;
      handleResults()
    }
  }, [clicked]);

  const getMaxScore = async (resData) => {
    setMaxScore(resData && resData.length > 0 && (resData[0]['@search.score']).toFixed(2));
  }

  const handleResults = async () => {
    setLoading(true);
    if (requestSkip < 0) {
      requestSkip = 0;
    }
    getMaxScore();
    const {
      pageData: resData,
      data: value,
      numOfPaginationButtons,
      total,
    } = await fetchSearchResults(
      {
        top: 100,
        requestSkip,
        searchValue,
        curLang,
        selectedLang,
        selectedSearchMode,
        selectedSearchType,
        selectedSearchField,
        selectedFromDate,
        selectedToDate,
        highlightPreTag: "<b>",
        highlightPostTag: "</b>",
      });
    if (requestSkip === 0) {
      getMaxScore(resData)
    }
    setPageData(resData);
    setData(value);
    setNumOfPaginationBtns(numOfPaginationButtons);
    const numOfAllPages = Math.ceil(total / 10);
    const pagesCounts = Math.ceil(numOfAllPages / 10);
    const arr = Array.from({ length: Math.ceil(total / 10) }, (_, i) => i + 1)
    const pages = {};
    let startOffset = 0;
    let endOffset = 10;
    for (let i = 0; i < pagesCounts; i++) {
      pages[i + 1] = arr.slice(startOffset, endOffset);
      startOffset = startOffset + 10;
      endOffset = endOffset + 10;
    }
    setPagesNumbers(pages);
    setLoading(false);
    setTotalResultsCount(total);
  }

  return (
    <div className='pagination-container'>
      {
        loading
          ?
          <h2 style={{ textAlign: 'center' }}>Loading ....</h2>
          :
          <>
            {
              <div>
                <div style={{ display: "flex", }}>
                  <div style={{ display: "flex", margin:8 }}>
                    <div className="high" style={{ backgroundColor: `${process.env.REACT_APP_HIGH_SCORE_COLOR}` }}></div>
                    <div style={{ marginTop: 4 }}>{vocabularies[curLang]['search']['highScore']}</div>
                  </div>
                  <div style={{ display: "flex", margin:8 }}>
                    <div className="medium" style={{ backgroundColor: `${process.env.REACT_APP_MEDIUM_SCORE_COLOR}` }}></div>
                    <div style={{ marginTop: 4 }}>{vocabularies[curLang]['search']['mediumScore']}</div>
                  </div>
                  <div style={{ display: "flex", margin:8 }}>
                    <div className="low" style={{ backgroundColor: `${process.env.REACT_APP_LOW_SCORE_COLOR}` }}></div>
                    <div style={{ marginTop: 4 }}>{vocabularies[curLang]['search']['lowScore']}</div>
                  </div>
                </div>
                <div className='total-results'>
                  <span className='total-counts'> <span style={{ color: '#00AEEF', fontWeight: 'bold', paddingRight: 3 }}>{vocabularies[curLang]['search']['total']}: </span> {totalResultsCount}</span>
                </div>
                {
                  <div className='pagination-buttons'>
                    {pagesNumbers[pageCount - 1] && pagesNumbers[pageCount - 1].length
                      ?
                      <Button
                        className='arrow-back'
                        onClick={() => {
                          requestSkip = requestSkip - 100;
                          if (requestSkip < 50) {
                            // setShowLess(false)
                            setSkip(0);
                          }
                          setPageCount(pageCount - 1)
                          handleResults();
                        }}>
                        {curLang === 'AR' ? <ArrowForwardIos /> : <ArrowBackIos />}
                      </Button>
                      :
                      null
                    }
                    {numOfPaginationBtns > 0 &&
                      Array.from(Array(numOfPaginationBtns), (e, i) => (
                        <Button
                          className='pagination-num-btn'
                          disabled={skip === i * 10}
                          onClick={() => {
                            if (i * 10 <= data.length) {
                              setSkip(i * 10);
                              setPageData(data.slice(i * 10, i * 10 + 10));
                            }
                            if ((i === 0 || i === numOfPaginationBtns - 1) && requestSkip <= 0) {
                              setLoading(false);
                            }
                          }}>
                          {pageCount == 1 ? i + 1 : parseInt((pageCount - 1).toString() + (1).toString()) + i}
                        </Button>
                      ))}
                    {pagesNumbers[pageCount + 1] && pagesNumbers[pageCount + 1].length ?
                      <Button
                        className='arrow-forward'
                        onClick={() => {
                          setSkip(0);
                          requestSkip = requestSkip + 100;
                          handleResults();
                          setPageCount(pageCount + 1)
                        }}>
                        {curLang === 'AR' ? <ArrowBackIos /> : <ArrowForwardIos />}
                      </Button>
                      :
                      null
                    }
                  </div>
                }
                {pageData.length
                  ?
                  <SearchTable
                    searchValue={searchValue}
                    filteredData={pageData}
                    vocabularies={vocabularies}
                    curLang={curLang}
                    languages={languages}
                    selectedLang={selectedLang}
                    maxScore={maxScore}
                  />
                  :
                  <h1 style={{ textAlign: 'center' }}>No Results</h1>
                }

              </div>
            }
          </>
      }
    </div>
  )
}
